import { useEffect } from "react";

export function useDisabledOverscroll() {
  // remove overscroll behavior on the body
  useEffect(() => {
    document.body.style.overscrollBehaviorX = "none";
    document.body.style.overscrollBehaviorY = "none";
    document.body.style.overflow = "hidden";
    document.body.style.height = "100vh";
    document.body.style.width = "100vw";
    document.body.style.minWidth = "100vw";
    document.body.style.maxWidth = "100vw";
    document.body.style.minHeight = "100vh";
    document.body.style.maxHeight = "100vh";
  }, []);
}
